import Sortable from "sortablejs";

import type { IArticleOptionGroupAlloc } from "@/data/commands/catalog/CreateArticleCmd";
import type { IArticleOptionGroup } from "@/data/model/Article";
import { Format } from "@/data/util/Format";

import { translate } from "@/shared/localization/language";

import { i18n } from "@/portal/Trans";
import { AddOptionGroupWindow } from "@/portal/modal/AddOptionGroupWindow";

export class OptionGroupAllocator {
    private addWindow?: AddOptionGroupWindow;

    private $element: JQuery;

    private $options: JQuery;
    private optionSortable: any;

    constructor() {
        this.$element = $('<div class="optiongroupallocator" />');

        const addRow = $('<div class="row addrow" />').appendTo(this.$element);
        const addBtn = $(
            '<div class="col-xl-9 pull-right"><button type="button" class="btn pull-right btn-success"><i class="la la-plus"></i> ' +
                i18n("general.entities.optionGroup") +
                "</button></div>"
        )
            .appendTo(addRow)
            .find("> .btn");
        addBtn.click((e) => {
            e.preventDefault();
            this.openAddWindow();
        });

        const optionRow = $('<div class="row optrow form-group" />').appendTo(this.$element);
        optionRow.append(
            '<label class="col-xl-3 col-lg-3 col-form-label">' + i18n("general.entities.optionGroups") + "</label>"
        );
        this.$options = $('<div class="col-lg-9 col-xl-6 options" />').appendTo(optionRow);

        this.optionSortable = Sortable.create(this.$options[0], {
            handle: ".draghandle",
            ghostClass: "draging",
            animation: 150,
            draggable: ".option",
            onEnd: (evt) => {
                if (evt.newIndex === evt.oldIndex) return;
            },
        });

        this.checkNoData();
    }

    public setValue(groups?: Array<IArticleOptionGroup>): OptionGroupAllocator {
        if (groups === undefined) {
            this.$options.empty();
        } else {
            this.$options.empty();
            for (const i in groups.sort((a, b) => a.order - b.order)) this.addOption(groups[i]);
        }

        this.checkNoData();

        return this;
    }

    public getValue(): Array<IArticleOptionGroupAlloc> {
        const val = new Array<IArticleOptionGroupAlloc>();

        let orderIt = 0;
        this.$options.find("> .option").each((i, e) => {
            const el = $(e);
            const optionGroup = el.data("model");

            val.push({
                optionGroupId: optionGroup.id,
                order: orderIt,
            });

            orderIt++;
        });

        return val;
    }

    private addOption(group: IArticleOptionGroup) {
        const opt = $('<div class="option" />').data("model", group).appendTo(this.$options);

        let name = group.internalName;
        if (name === undefined || name === "") name = translate(group.name);

        opt.append(
            '<a class="name" href="/optiongroup/' + group.id + '" target="_blank">' + Format.htmlEscape(name) + "</a>"
        );

        $('<div class="remover"><i class="la la-trash"></i></div>')
            .appendTo(opt)
            .click((e) => {
                $(e.currentTarget).parent().remove();
                this.checkNoData();
            });

        $('<div class="draghandle"><i class="la la-bars"></i></div>').appendTo(opt);
    }

    private openAddWindow() {
        if (this.addWindow === undefined) {
            this.addWindow = new AddOptionGroupWindow();
            this.addWindow.onSelected = (groups) => {
                //check if option is already in list
                const val = this.getValue();

                for (const i in groups) {
                    if (val.find((c) => c.optionGroupId === groups[i].id) !== undefined) continue;

                    this.addOption({
                        id: groups[i].id,
                        name: groups[i].name,
                        internalName: groups[i].internalName,
                        order: null!,
                        maxPerOption: groups[i].maxPerOption,
                    });
                }

                this.checkNoData();
            };
        }

        const groups = new Array<string>();
        this.$options.find("> .option").each((i, e) => {
            groups.push($(e).data("model").id);
        });

        this.addWindow.setAlreadyAddedGroups(groups).show();
    }

    private checkNoData() {
        const cont = this.$options.find("> .nodata");

        if (this.$options.find("> .option").length === 0) {
            if (cont.length === 0)
                this.$options.append(
                    '<div class="nodata">' + i18n("elements.optionGroupAllocator.noGroups") + "</div>"
                );
        } else {
            if (cont.length !== 0) cont.remove();
        }
    }

    public renderTo($element: JQuery): OptionGroupAllocator {
        this.$element.appendTo($element);

        return this;
    }

    public replaceWith($element: JQuery): OptionGroupAllocator {
        $element.replaceWith(this.$element);

        return this;
    }
}
